module.exports = __webpack_public_path__ + "assets/img/logo.1fb57d7a.svg";